function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { isSafari } from 'react-device-detect';
import typography from '../utils/typography';
import nativeFocus from '../utils/native_focus';
import { useTheme } from '@veneer/theme';
var useTabListStyles = _ref => {
  var {
    hasOverflow
  } = _ref;
  var theme = useTheme();
  var isHc = theme.mode === 'contrast';
  var borderBoxGhostElement = {
    content: "' '",
    backgroundColor: 'transparent',
    display: 'block',
    height: 16,
    width: theme.borderRadius2 === '0px' && !hasOverflow ? '0%' : '100%',
    maxWidth: hasOverflow ? 39 : 16,
    border: '1px solid transparent',
    borderTopColor: theme.palette.stroke.default,
    position: 'absolute',
    top: 47
  };
  return {
    base: {
      display: 'flex',
      position: 'relative'
    },
    baseOnline: {
      width: 'fit-content',
      maxWidth: '100%'
    },
    baseAttached: _objectSpread({}, isHc && {
      '&::after': _objectSpread(_objectSpread({}, borderBoxGhostElement), {}, {
        borderLeftColor: theme.palette.stroke.default,
        borderTopLeftRadius: theme.borderRadius5,
        left: 0
      }),
      '&::before': _objectSpread(_objectSpread({}, borderBoxGhostElement), {}, {
        borderRightColor: theme.palette.stroke.default,
        borderTopRightRadius: theme.borderRadius5,
        right: 0
      })
    }),
    baseContained: _objectSpread({
      backgroundColor: theme.palette.background.container,
      boxShadow: theme.level.level4
    }, isHc && {
      margin: -1,
      border: "1px solid ".concat(theme.palette.stroke.default)
    }),
    baseExtended: {
      '&::after': {
        content: "' '",
        display: 'block',
        height: 2,
        borderRadius: theme.borderRadius4,
        background: theme.palette.stroke.default,
        position: 'absolute',
        bottom: 0,
        left: 0,
        right: 0
      }
    },
    baseOutlined: {
      '&::after': _objectSpread(_objectSpread({}, borderBoxGhostElement), {}, {
        borderLeftColor: theme.palette.stroke.default,
        borderTopLeftRadius: theme.borderRadius5,
        left: 0
      }),
      '&::before': _objectSpread(_objectSpread({}, borderBoxGhostElement), {}, {
        borderRightColor: theme.palette.stroke.default,
        borderTopRightRadius: theme.borderRadius5,
        right: 0
      })
    },
    utilityButton: {
      display: !hasOverflow ? 'none' : undefined,
      margin: '8px 4px',
      position: 'relative'
    },
    tabs: {
      scrollBehavior: !isSafari ? 'smooth' : undefined,
      display: 'inline-flex',
      flex: '1 1 auto',
      overflow: 'hidden',
      boxSizing: 'border-box',
      flexFlow: 'row nowrap'
    },
    tabsAttached: _objectSpread(_objectSpread({}, !hasOverflow && {
      paddingLeft: theme.borderRadius2 === '0px' ? 0 : 16,
      paddingRight: theme.borderRadius2 === '0px' ? 0 : 16
    }), isHc && {
      '&::after': {
        content: "' '",
        display: 'flex',
        flex: '1 1 auto',
        borderBottom: "1px solid ".concat(theme.palette.stroke.default)
      }
    }),
    tabsDropShadow: _objectSpread({
      marginTop: -4,
      paddingTop: 4
    }, hasOverflow ? {
      marginLeft: -4,
      paddingLeft: 4
    } : {
      marginLeft: theme.borderRadius2 === '0px' ? -4 : undefined,
      paddingLeft: theme.borderRadius2 === '0px' ? 4 : undefined
    }),
    tabsOutlined: {
      '&::after': {
        content: "' '",
        display: 'flex',
        flex: '1 1 auto',
        borderBottom: "1px solid ".concat(theme.palette.stroke.default)
      }
    },
    tab: _objectSpread(_objectSpread(_objectSpread({}, nativeFocus(theme)), typography(theme).label), {}, {
      height: 48,
      padding: '0 16px',
      boxSizing: 'border-box',
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      cursor: 'pointer',
      color: isHc ? theme.palette.primary.default : theme.palette.foreground.default,
      position: 'relative',
      '&:hover': _objectSpread({
        backgroundColor: isHc ? theme.palette.neutral.hover : theme.palette.neutral.backgroundLight,
        '&::after': {
          background: isHc ? 'transparent' : theme.palette.neutral.hover
        }
      }, isHc && {
        color: theme.palette.foreground.inverse
      }),
      '&:active': _objectSpread({
        backgroundColor: isHc ? theme.palette.neutral.active : theme.palette.neutral.background,
        '&::after': {
          background: isHc ? 'transparent' : theme.palette.neutral.active
        }
      }, isHc && {
        color: theme.palette.foreground.inverse
      }),
      '&::after': {
        content: "' '",
        display: 'block',
        height: 2,
        borderRadius: theme.borderRadius2,
        backgroundColor: 'trasparent',
        position: 'absolute',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 1
      }
    }),
    tabOnline: {
      '&:hover': {
        '&::after': {
          background: theme.palette.neutral.hover
        }
      },
      '&:active': {
        '&::after': {
          background: theme.palette.neutral.active
        }
      }
    },
    tabLabel: {
      minWidth: '72px',
      display: 'inline-flex',
      whiteSpace: 'nowrap'
    },
    tabAttached: _objectSpread({
      borderTopLeftRadius: theme.borderRadius4,
      borderTopRightRadius: theme.borderRadius4,
      border: "1px solid transparent",
      borderBottom: 'none',
      '&::after': {
        left: 16,
        right: 16
      }
    }, isHc && {
      '&::before': {
        content: "' '",
        display: 'block',
        height: 1,
        position: 'absolute',
        backgroundColor: theme.palette.stroke.default,
        bottom: 0,
        left: -1,
        right: -1,
        zIndex: 1
      }
    }),
    tabOutlined: {
      '&::before': {
        content: "' '",
        display: 'block',
        height: 1,
        position: 'absolute',
        backgroundColor: theme.palette.stroke.default,
        bottom: 0,
        left: -1,
        right: -1,
        zIndex: 1
      }
    },
    tabSelected: _objectSpread({
      color: isHc ? theme.palette.foreground.inverse : theme.palette.primary.default,
      '&::after': {
        backgroundColor: theme.palette.primary.default
      },
      '&::before': {
        backgroundColor: 'transparent'
      },
      '&:hover': {
        color: isHc ? theme.palette.foreground.inverse : theme.palette.primary.hover,
        '&::after': {
          background: theme.palette.primary.hover
        }
      },
      '&:active': {
        backgroundColor: theme.palette.primary.backgroundLight,
        color: isHc ? theme.palette.foreground.inverse : theme.palette.primary.active,
        '&::after': {
          background: theme.palette.primary.active
        }
      }
    }, isHc && {
      borderColor: theme.palette.stroke.default,
      backgroundColor: theme.palette.primary.default
    }),
    tabSelectedOnline: {
      '&:hover': {
        backgroundColor: isHc ? theme.palette.neutral.hover : theme.palette.primary.backgroundLight
      },
      '&:active': {
        backgroundColor: isHc ? theme.palette.neutral.active : theme.palette.primary.background
      }
    },
    tabSelectedAttached: {
      backgroundColor: isHc ? theme.palette.primary.default : theme.palette.background.container,
      '&:hover': {
        backgroundColor: isHc ? theme.palette.neutral.hover : theme.palette.background.container
      },
      '&:active': {
        backgroundColor: isHc ? theme.palette.neutral.active : theme.palette.background.container
      }
    },
    tabSelectedOutlined: {
      borderColor: theme.palette.stroke.default,
      borderBottomColor: 'transparent',
      backgroundColor: isHc ? theme.palette.primary.default : 'transparent',
      '&:hover': {
        backgroundColor: isHc ? theme.palette.neutral.hover : 'transparent'
      },
      '&:active': {
        backgroundColor: isHc ? theme.palette.neutral.active : 'transparent'
      }
    },
    tabSelectedDropShadow: {
      boxShadow: theme.level.level4
    }
  };
};
export default useTabListStyles;